export function base64ToBlob(base64DataURI, contentType) {
  if (!(base64DataURI.length > 0)) throw new Error("Invalid Base64 Data URI.");
  if (!(contentType.length > 0)) throw new Error("Invalid Content-Type.");

  const byteString = atob(base64DataURI.split(",", 2)[1]);
  const binaryData = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    binaryData[i] = byteString.charCodeAt(i);
  }

  return new Blob([binaryData], { type: contentType });
}
